module.exports = __webpack_public_path__ + "assets/images_base/st-audio.svg?v=2b774171";